import { downloadAsAttachment } from '@api/HelperAPI';
import { fetchGetCreditCardStatementsDownload } from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

import { useStateKey } from '../../../iwQueryClient/useStateKey';

export const useFetchCreditCardStatementContent = ({
    documentId,
    enabled = true,
    suspense = true
}: {
    documentId: string;
    enabled?: boolean;
    suspense?: boolean;
}) => {
    const stateKey = useStateKey();

    const { data, refetch } = useQuery({
        queryKey: ['credit-card-document', stateKey, documentId],
        queryFn: async () => {
            const responseData = await fetchGetCreditCardStatementsDownload({
                stateKey,
                statementId: documentId
            });

            return downloadAsAttachment(responseData);
        },
        enabled: enabled,
        suspense: suspense
    });

    return { data: data, refetch };
};
